import { useTranslation } from 'react-i18next';
import OfferContactForm from '@components/OfferContactForm.jsx';
import { XIcon } from 'lucide-react';
import { Alert } from '@eye-able/ui';

export function ReportLicenseExpiredBanner() {
  const { t } = useTranslation();

  return (
    <Alert variant={'error'}>
      <div className='eye:flex eye:items-center eye:gap-2xs'>
        <XIcon aria-hidden className='eye:text-red-100' />
        <div className='eye:flex eye:max-md:flex-col eye:items-center eye:gap-2xs'>
          <div className='eye:font-semibold eye:text-black'>
            {t('reportLicenseExpired')}
          </div>

          <OfferContactForm product={'Eye-Able Report'} />
        </div>
      </div>
    </Alert>
  );
}
